













































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import user from '@/store/modules/user';
import CompanyMixin from '@/mixins/CompanyMixin';
import { CompanySie } from '../store/models';
import * as api from '@/store/api';

@Component
export default class SieMeta extends CompanyMixin {
    @Prop() readonly sie!: CompanySie;

    rankingM = {};
    plM = {};
    bsM = {};

    @Watch('sie', { immediate: true, deep: true })
    async onSieChanged() {
        this.rankingM = await api.getRankingSie(this.sie.AggVersion, this.orgNr());
        this.plM = await api.getProfitLossSie(this.sie.AggVersion, this.orgNr());
        this.bsM = await api.getBalanceSie(this.sie.AggVersion, this.orgNr());
    }

    get range() {
        return `${this.sie.PeriodStart} till ${this.sie.PeriodEnd}`;
    }

    get isInFuture() {
        const end = this.sie.PeriodEnd;
        const created = this.sie.Created.substring(0, 10);
        return end > created;
    }

    get ranking() {
        return this.rankingM;
    }

    get pl() {
        return this.plM;
    }

    get bs() {
        return this.bsM;
    }
}
